<mg-simple-form *ngIf="form" label="Visitor" title="#{{item?.id}}" [dtoClassName]="dtoTypeName" [formGroup]="form">
  <mg-simple-form-row>
    <div class="form-field-1">
      <mat-form-field>
        <input type="text" placeholder="Naam" matInput formControlName="name">
        <mat-label>Naam Bezoeker</mat-label>
      </mat-form-field>
    </div>

    <div class="form-field-meeting">
      <mat-form-field>
        <input type="text" placeholder="Werknemer" matInput formControlName="meetingPerson">
        <mat-label>Wie gaat de bezoeker ontmoeten</mat-label>
      </mat-form-field>
    </div>

    <div class="buttons">
      <button mat-button (click)="setOption('company')" [ngClass]="{ 'selected': selectedOption === 'company' }">
        Bedrijf
      </button>
      <button mat-button (click)="setOption('school')" [ngClass]="{ 'selected': selectedOption === 'school' }">School
      </button>
      <button mat-button (click)="setOption('other')" [ngClass]="{ 'selected': selectedOption === 'other' }">Anders
      </button>
    </div>

    <div class="form-field-option">
      <ng-container *ngIf="selectedOption === 'company'">
        <div class="form-field">
          <mat-form-field>
            <input matInput placeholder="Bedrijfsnaam" formControlName="company">
            <mat-label>Vul de bedrijfsnaam van de klant in</mat-label>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedOption === 'school'">
        <div class="form-field">
          <mat-form-field>
            <input matInput placeholder="School naam" formControlName="school">
            <mat-label>Vul de schoolnaam in</mat-label>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedOption === 'other'">
        <div class="form-field">
          <mat-form-field>
            <input matInput placeholder="Bezoek Reden" formControlName="other">
            <mat-label>Vul de reden van het bezoek in</mat-label>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="information-date">
      <div class="form-field-1">
        <mat-form-field>
          <input matInput [ngxMatDatetimePicker]="picker3" placeholder="Aanmeld tijd" formControlName="registerTime">
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker3></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>

      <div class="form-field-1">
        <mat-form-field>
          <input matInput [ngxMatDatetimePicker]="picker2" placeholder="Afmeld tijd" formControlName="unregisterTime">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker2></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>

      <div class="information">
        <p>Aangemeld om: <strong>{{ item?.registerTime | date: 'medium' }}</strong></p>
        <p>Afgemeld om: <strong>{{ form.get('unregisterTime')?.value | date: 'medium' }}</strong></p>
        <p>Bezoek duur: {{ totalDuration | duration }}</p>
      </div>
    </div>
  </mg-simple-form-row>
</mg-simple-form>
